export const PatientSurgeryExamResultsCard = ({ eventFiles = [] }) => {
  return (
    <div className="card border shadow">
      <div className="card-body">
        {eventFiles.length > 0 ? (
          <div className="list-group">
            {eventFiles.map((file) => (
              <a
                key={file.id}
                target="_blank"
                href={file.url}
                className="list-group-item list-group-item-action"
              >
                {file.fileName}
              </a>
            ))}
          </div>
        ) : (
          <p className="mb-0">El paciente no subió exámenes médicos.</p>
        )}
      </div>
    </div>
  );
};
